import useGetCountryFromUrl from '@fingo/lib/hooks/useGetCountryFromUrl';
import { COUNTRIES } from '@fingo/lib/constants/countries';

const isMexicoEnabled = process.env.REACT_APP_ENABLE_MEXICO !== 'false';

const useIsMexicoRegistrationDisabled = () => {
  const country = useGetCountryFromUrl();
  return country?.name === COUNTRIES.MEXICO && !isMexicoEnabled;
};

export default useIsMexicoRegistrationDisabled;
